module.exports = __webpack_public_path__ + "assets/img/246601.aa9b83f1.svg";